import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { apiGetContribsEspacePrincipalColidee } from "../../../api/ApiColidee";
import ComponentTitle from "../../layout/ComponentTitle";
import bandeauContribution from "../../../assets/images/bandeauContribution.jpg";
import { Image } from "react-bootstrap";
import ComponentLoader from "../../layout/ComponentLoader";
import { toDateTimeFR } from "../../../utils/datesHeures";
import { BiMessageDetail } from "react-icons/bi";
import ComponentThemesContribution from "../colidee/ComponentThemesContribution";
import ComponentTitleAndSousTitle from "../../layout/ComponentTitleAndSousTitle";

const BlocEpingle3 = () => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const [contributions, setContributions] = useState([]);
  const { ReduxToken } = useSelector((state) => state.ReduxToken);
  const [loader, setLoader] = useState(false);

  const recupDatas = async () => {
    if (ReduxInstance.espacePrincipalColidee && ReduxInstance.espacePrincipalColidee !== 0) {
      const form = new FormData();
      form.append("espacePrincipalColidee", ReduxInstance.espacePrincipalColidee);
      const res = await apiGetContribsEspacePrincipalColidee(ReduxToken, form);
      setContributions(res.data.slice(0, 5));
    }
    setLoader(false);
  };

  const backgroundBandeauColidee = (illustrationContribution) => {
    if (illustrationContribution) return illustrationContribution;
    else return bandeauContribution;
  };

  useEffect(() => {
    if (ReduxInstance.modulesActives.includes("accueil3")) {
      setLoader(true);
      recupDatas();
    }
  }, [ReduxInstance]); // eslint-disable-line react-hooks/exhaustive-deps

  function urlify(text) {
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.replace(urlRegex, function (url) {
      return url.substring(0, url.indexOf("/", 7) > 0 ? url.indexOf("/", 7) : url.length);
    });
  }

  return (
    ReduxInstance.espacePrincipalColidee !== 0 &&
    ReduxInstance.modulesActives.includes("accueil3") && (
      <div className="hackHomeEthicsTransparent">
        <ComponentTitleAndSousTitle title={t("public.pageHome.titleBloc3")} />
        <br />
        {loader && <ComponentLoader />}

        {contributions.length > 0 && (
          <div className="containerBlocEpingle ">
            <div className="blocSecondaire d-flex justify-content-between">
              {contributions.slice(0, 3).map((contribution, index) => (
                <a
                  href={
                    process.env.REACT_APP_URL_COLIDEE +
                    "o" +
                    contribution.id_entreprise +
                    "p" +
                    contribution.id_plateforme +
                    "/participation-" +
                    contribution.id_contribution +
                    ".htm"
                  }
                  target="_blank"
                  rel="noreferrer"
                  key={"secondaire" + index}
                  className="d-flex flex-nowrap mb-3 colonne2"
                >
                  <div
                    className="blocIllustration"
                    style={{
                      backgroundImage: contribution.illustrationSmall
                        ? `url(` + contribution.illustrationSmall + `)`
                        : `url(` +
                          process.env.REACT_APP_URL_COLIDEE +
                          "img/medailloneasygouv.png" +
                          `)`,
                    }}
                  ></div>
                  <div className="contribution flex-grow-1">
                    <div className="categorieArticles">
                      {t("public.pageHome.categorieObjet8")}
                      <span className="float-end">
                        {toDateTimeFR(contribution.datePublication)}
                      </span>
                    </div>
                    <div className="identite">
                      <Image
                        src={contribution.pictureColideur}
                        className="m-1 rounded-circle avatar"
                      />
                      {contribution.prenomColideur} {contribution.nomColideur}
                    </div>
                    <ComponentThemesContribution contribution={contribution} />
                    {urlify(contribution.contribution)}

                    <div className="mt-2 nomPlateforme">
                      {contribution.nomPlateforme} <br />
                      <BiMessageDetail size="1.5em" /> {contribution.NbrContributions}
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        )}
      </div>
    )
  );
};

export default BlocEpingle3;
